
import { Component, Vue } from "vue-property-decorator";
import { getOperationNameByMac } from "@/api/monitorGateway";
import { SystemConfigModule } from "@/store/modules/store_systemconfig";
import { LogHelper } from "@/common/LogHelper";

@Component({
  name: "Form1",
})
export default class extends Vue {
  private inputModel: inputDataModel_BackFlow = {
    input_ScanCode: "",
    input_latticeNo: "",
    circleLine: 0,
    maxLatticeNo: 0,
    deviceAttribute: 0
  };
  public globalConfig: any = {};
  public latticeNoRequired = false;
  mounted() {
    this.globalConfig = SystemConfigModule.globalData;
    try {
      this.inputModel.input_latticeNo = "";
      this.GetOperationNameByMac();
    } catch (error) {
      console.log(error);
    }
    this.$emit("get-form1-value", this.inputModel);
  }

  private async GetOperationNameByMac() {
    try {
      const { data } = await getOperationNameByMac(
        this.globalConfig.LocalMac,
        ""
      );
      if (data != null && data.respCode == "000") {
        if (data.data.deviceAttribute == 2) {
          this.inputModel.deviceAttribute = 2;
          this.inputModel.circleLine = 1;
          if (data.data.matrixLatticeNo) {
            var latticeno = data.data.matrixLatticeNo + "";
            var _pre = "";
            for (let index = 0; index < 3 - latticeno.length; index++) {
              _pre += "0";
            }
            this.inputModel.input_latticeNo = _pre + latticeno;
          }
        } else {
          this.inputModel.circleLine = 0;
        }

        if (data.data.deviceAttribute == 3) {
          this.inputModel.deviceAttribute = 3;
          if (data.data.adapterDevice) {
            var latticeno = data.data.adapterDevice + "";
            this.inputModel.input_latticeNo = latticeno;
          }
        }
      }
    } catch (error) {
      LogHelper.Error("获取格口号出现异常:" + error);
    }
  }
}
